import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { HashRouter } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import App from './pages/App';
import * as serviceWorker from './serviceWorker';
import zhCN from './i18n/zh-CN.json';

// simplified
const locale = navigator.language || 'zh-CN';
const messages = { 'zh-CN': zhCN };// getMessages(locale);
console.log('locale', locale, messages);
ReactDOM.render(
  <React.StrictMode>
    <IntlProvider
      locale="zh-CN"
      defaultLocale="zh-CN"
      messages={messages['zh-CN']} // messages?: {[id: string]: string}
    >
      <HashRouter>
        <App />
      </HashRouter>
    </IntlProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
